module.exports = __webpack_public_path__ + "static/media/banana_tree.39c2cdea.gif";